import {IconVisitorManagementDesign} from '../../../components/buttons/IconButtons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import FullPageLoader from '../../../utils/FullPageLoader';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean loading: for the loading page
 */
const SuccessIdentity = ({loading}) => {
    const { t } = useTranslation();

    return (
        <>
            { loading
                ?
                <FullPageLoader className="background-linear-gradient-950-opacity025"/>
                :
                <>
                    <div className="d-flex flex-column gap-2">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("thank_you_for_validating_your_identity")}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950">{t("your_process_has_been_successfully_completed")}</p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center pt-2">
                        <div className="icon-submitting-validation-container">
                            <IconVisitorManagementDesign className="w-100 h-100" />
                        </div>
                    </div>
                </>
            }
        </>
    );

}

export default SuccessIdentity
